<template>
  <div>
    <spinner-component :loading="loading"></spinner-component>
    <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
    <v-card>
      <v-card-title>
        Dane do faktury
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="invoice.companyInvoice">
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="Nazwa firmy"
                  v-model="invoice.companyName"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="NIP"
                  v-model="invoice.nip"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!invoice.companyInvoice">
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="Imię"
                  v-model="invoice.name"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="Nazwisko"
                  v-model="invoice.surname"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="Ulica"
                  v-model="invoice.street"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  :disabled="!edit"
                  label="Numer domu"
                  v-model="invoice.houseNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="2" v-if="invoice.aptNumber">
              <v-text-field
                  :disabled="!edit"
                  label="Numer lokalu"
                  v-model="invoice.aptNumber"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field
                  :disabled="!edit"
                  label="Kod pocztowy"
                  v-model="invoice.zipCode"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  :disabled="!edit"
                  label="Miasto"
                  v-model="invoice.city"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="Kraj"
                  v-model="invoice.country"
                  :disabled="!edit"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                  label="Adres email"
                  v-model="invoice.email"
                  :disabled="!edit"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  :disabled="!edit"
                  label="Numer telefonu"
                  v-model="invoice.phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn block
                     color="primary"
                     elevation="2"
                     large
                     :disabled="edit"
                     @click="generateInvoice()"
              >
                Pobierz fakturę
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="edit" @click="edit = true">Edytuj</v-btn>
        <v-btn :disabled="!edit" @click="save()">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

import {saveAs} from "file-saver";
import {computed} from "vue";
import SpinnerComponent from "@/components/SpinnerComponent";
import ErrorDialogComponent from "@/components/ErrorDialogComponent";
import {invoiceApiClient} from "@/api/invoice.api.client";
import {ordersApiClient} from "@/api/orders.api.client";

export default {
  name: 'OrderInvoiceDetails',
  inheritAttrs: false,
  components: {SpinnerComponent, ErrorDialogComponent},
  props: {
    orderId: String,
    orderVisibleId: String,
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    invoice() {
      return this.modelValue ? this.modelValue : {}
    }
  },

  emits: ['update:modelValue'], // The component emits an event
  setup(props, {emit}) {
    const theModel = computed({  // Use computed to wrap the object
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    return {theModel};
  },

  data() {
    return {
      edit: false,

      // MISC
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false,
        callback: undefined
      }
    }
  },

  created() {
  },

  methods: {
    generateInvoice() {
      this.loading = true;
      invoiceApiClient.getInvoice(this.orderId, (response) => {
        if (response.status === 200) {
          saveAs(response.data, `${this.orderVisibleId}_invoice.pdf`);
        } else if (response.status === 204) {
          this.errorDialog.visible = true;
          this.errorDialog.errorMessage = "Nie można pobrać faktury dla zamówienia które nie zostało jeszcze opłacone lub kwota zamówienia wynosi 0 zł";
        } else {
          this.errorDialog.visible = true;
          this.errorDialog.errorMessage = "Nie znany kod, skontaktuj się z administratorem";
        }
      }, error => {
        this.errorDialog.visible = true;
        this.errorDialog.errorMessage = error.response.data.detail;
        console.error(error);
      }, () => this.loading = false)
    },

    save() {
      this.loading = true;
      ordersApiClient.updateInvoiceData(this.orderId, this.invoice, () => {
      }, error => {
        this.errorDialog.visible = true;
        this.errorDialog.errorMessage = error.response.data.detail;
        this.errorDialog.callback = () => this.$router.go(0);
      }, () => {
        this.loading = false;
        this.edit = false;
      })
    }
  }
};
</script>
